import { Blockquote } from "@radix-ui/themes";

export default function ZVisionBanner() {
  return (
    <>
      <Blockquote size="8" color>
        Vision
      </Blockquote>
    </>
  )
}
